import { NgModule } from '@angular/core';
import { MathTruncPipe } from './math-trunc.pipe';

@NgModule({
    declarations: [MathTruncPipe],
    exports: [MathTruncPipe],
})
export class MathTruncPipeModule {}
